<template>
    <div class="tabletView">
        <div>
            <div id="checkin_overlay"></div>
            <div class="checkin_infoBox">
                <div id="checkin_message_headline"></div>
                <div id="checkin_message"></div>
                <div class="checkin_infoBox_footer">
                    <span
                        class="checkin_message_close checkin_button"
                        @click="hide_infoBox('infoBox')"
                    >{{ $t('ok.ok') }}</span>
                    <span
                        class="checkin_message_login checkin_button"
                        onclick="window.location.href='https://www.kigaroo.de/login'"
                    >{{ $t('Zurück zum Login') }}</span>
                </div>
            </div>

            <div id="header">
                <div
                    v-if="kindergarten.logo"
                    id="dashboard-kindergartenlogo"
                >
                    <div style="background-color: white">
                        <img :src="kindergarten.logo" />
                    </div>
                </div>
                <div class="dashboard-header">
                    <div v-if="navigationIsVisible">
                        <div class="menu-icon">
                            <i
                                class="icon"
                                :class="{
                                    'icon-user-plus': menuCheckIn,
                                    'icon-user-times': menuCheckOut,
                                    'icon-smile-o mood-nav-icon': menuMoodBarometer
                                }"
                            ></i>
                        </div>
                        <ul class="dashboard-list">
                            <li
                                v-for="group in groups"
                                :class="{ 'active': isGroupSelected(group.id) }"
                                @click="toggleGroup(group.id)"
                            >
                                {{ group.name }}
                            </li>
                        </ul>
                        <ul class="dashboard-return">
                            <li
                                :title="$t('child_checkin_back_to_choice')"
                                @click="showSelection()"
                            >
                                <i class="icon icon-home"></i>
                            </li>
                        </ul>

                        <div class="header-path">
                            <h2>{{ $t('child_checkin_headline_' + menu) }}</h2>
                        </div>
                        <br style="clear:both" />
                    </div>
                </div>
            </div>


            <div
                id="dashboard"
                class="container content"
            >
                <!-- main selection -->
                <div
                    v-if="menuSelection"
                    class="row dashboard-choice"
                >
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h1>{{ $t('child_checkin_start_selection_headline') }}</h1>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-4">
                            <a
                                href="#"
                                @click="menu = 'checkIn';setDefaultSortOrder()"
                            >
                                <div class="well text-center card-choice">
                                    <i class="icon icon-user-plus selection-nav-icon"></i>
                                    <p>{{ $t('child_checkin_start_but_check_in') }}</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-4">
                            <a
                                href="#"
                                @click="menu = 'checkOut';setDefaultSortOrder()"
                            >
                                <div class="well text-center card-choice">
                                    <i class="icon icon-user-times selection-nav-icon"></i>
                                    <p>{{ $t('child_checkin_start_but_check_out') }}</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-2"></div>
                    </div>

                    <div
                        v-if="moodBarometerEnabled"
                        class="row"
                    >
                        <div class="col-md-4"></div>
                        <div class="col-md-4">
                            <a
                                href="#"
                                @click="menu = 'moodBarometer';setDefaultSortOrder()"
                            >
                                <div class="well text-center card-choice">
                                    <i class="icon icon-smile-o mood-nav-icon selection-nav-icon"></i>
                                    <p>{{ $t('child_checkin_start_but_moodBarometer') }}</p>
                                </div>
                            </a>
                        </div>
                        <div class="col-md-4"></div>
                    </div>
                </div>

                <!-- checkIn -->
                <div
                    v-if="menuCheckIn"
                    class="row"
                >
                    <div class="col-md-12 sort-buttons">
                        {{ $t('child_checkin_sort_prefix') }}

                        <kgr-tablet-view-sort-button
                            v-model="sort.checkIn.firstname"
                            :label="$t('Vorname')"
                            @post-input="sortFirstname"
                        />
                        <kgr-tablet-view-sort-button
                            v-model="sort.checkIn.lastname"
                            :label="$t('Nachname')"
                            @post-input="sortLastname"
                        />
                        <kgr-tablet-view-sort-button
                            v-model="sort.checkIn.checkIn"
                            :label="$t('child_checkin_sort_checkin')"
                            @post-input="sortCheckin"
                        />
                    </div>
                    <div class="col-md-12">
                        <h2 v-if="childrenWithStatusNotHereYetAvailable">
                            {{ $t('child_checkin_arrive_not_arrived') }} ({{ childrenWithStatusNotHereYet.length }})
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusNotHereYet"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-card
                                    :child="child"
                                    :error-callback="onCardError"
                                    category="checkin"
                                    @update-attendance="updateAttendance($event)"
                                    @show-pickup-permission="showPickupPermission($event)"
                                    @hide-pickup-permission="hidePickupPermission()"
                                />
                            </div>
                        </div>

                        <h2 v-if="childrenWithStatusPresentAvailable">
                            {{ $t('child_checkin_arrive_already_there') }} ({{ childrenWithStatusPresent.length }})
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusPresent"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-card
                                    :child="child"
                                    :error-callback="onCardError"
                                    category="checkin"
                                    @update-attendance="updateAttendance($event)"
                                    @show-pickup-permission="showPickupPermission($event)"
                                    @hide-pickup-permission="hidePickupPermission()"
                                />
                            </div>
                        </div>
                        <h2 v-if="childrenWithStatusAbsentAvailable">
                            {{ $t('child_checkin_arrive_absent') }} ({{ childrenWithStatusAbsent.length }})
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusAbsent"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-card
                                    :child="child"
                                    :error-callback="onCardError"
                                    category="checkin"
                                    @update-attendance="updateAttendance($event)"
                                    @show-pickup-permission="showPickupPermission($event)"
                                    @hide-pickup-permission="hidePickupPermission()"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- checkOut -->
                <div
                    v-if="menuCheckOut"
                    class="row"
                >
                    <div class="col-md-12 sort-buttons">
                        {{ $t('child_checkin_sort_prefix') }}

                        <kgr-tablet-view-sort-button
                            v-model="sort.checkOut.firstname"
                            :label="$t('Vorname')"
                            @post-input="sortFirstname"
                        />
                        <kgr-tablet-view-sort-button
                            v-model="sort.checkOut.lastname"
                            :label="$t('Nachname')"
                            @post-input="sortLastname"
                        />
                        <kgr-tablet-view-sort-button
                            v-model="sort.checkOut.checkOut"
                            :label="$t('child_checkin_sort_checkout')"
                            @post-input="sortCheckout"
                        />
                    </div>
                    <div class="col-md-12">
                        <div
                            v-if="!childrenWithStatusesAvailable(['present', 'pickedUp'])"
                            class="notice"
                        >
                            <h3>{{ $t('Für die ausgewählten Gruppen wurden noch keine Kinder als anwesend markiert.') }}</h3>
                        </div>

                        <h2 v-if="childrenWithStatusPresentAvailable">
                            {{ $t('child_checkin_arrive_still_there') }} ({{ childrenWithStatusPresent.length }})
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusPresent"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-card
                                    :child="child"
                                    :error-callback="onCardError"
                                    category="checkout"
                                    @show-pickup-permission="showPickupPermission($event)"
                                    @hide-pickup-permission="hidePickupPermission()"
                                />
                            </div>
                        </div>
                        <h2 v-if="childrenWithStatusPickedUpAvailable">
                            {{ $t('child_checkin_leave_already_picked_up') }} ({{ childrenWithStatusPickedUp.length }})
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusPickedUp"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-card
                                    :child="child"
                                    :error-callback="onCardError"
                                    category="checkout"
                                    @show-pickup-permission="showPickupPermission($event)"
                                    @hide-pickup-permission="hidePickupPermission()"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- moodBarometer -->
                <div
                    v-if="menuMoodBarometer"
                    class="row"
                >
                    <div class="col-md-12 sort-buttons">
                        {{ $t('child_checkin_sort_prefix') }}

                        <kgr-tablet-view-sort-button
                            v-model="sort.moodBarometer.firstname"
                            :label="$t('Vorname')"
                            @post-input="sortFirstname"
                        />
                        <kgr-tablet-view-sort-button
                            v-model="sort.moodBarometer.lastname"
                            :label="$t('Nachname')"
                            @post-input="sortLastname"
                        />
                    </div>
                    <div class="col-md-12">
                        <div
                            v-if="!childrenWithStatusesAvailable(['present', 'pickedUp'])"
                            class="notice"
                        >
                            <h3>{{ $t('Für die ausgewählten Gruppen wurden noch keine Kinder als anwesend markiert.') }}</h3>
                        </div>

                        <h2 v-if="childrenWithStatusPresentAvailable">
                            {{ $t('child_checkin_moodBarometer_already_there') }}
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusPresent"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-moods-card
                                    :child="child"
                                    :error-callback="onCardError"
                                />
                            </div>
                        </div>
                        <h2 v-if="childrenWithStatusPickedUpAvailable">
                            {{ $t('child_checkin_leave_already_picked_up') }}
                        </h2>
                        <div class="children">
                            <div
                                v-for="child in childrenWithStatusPickedUp"
                                :id="'child-' + child.id"
                                :key="'child-' + child.id"
                                class="text-center child"
                            >
                                <kgr-tablet-view-child-moods-card
                                    :child="child"
                                    :error-callback="onCardError"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="footer">
            <div class="row">
                <div class="col-md-4">
                    <img
                        src="@img/logo/dashborad_footer.png"
                        :alt="$t('child_checkin_kindergarten_name_short')"
                    />
                </div>
                <div class="col-md-4">
                    www.kigaroo.de
                </div>
                <div class="col-md-4">
                    support@kigaroo.de
                </div>
            </div>
        </div>
        <kgr-tablet-view-pickup-list
            v-if="pickupPermissionChild !== null"
            :pickuplist="pickupPermissionChild.pickuplist"
            @hide-pickup-permission="hidePickupPermission()"
        />
    </div>
</template>

<script>
import EventBus from '../../js/service/EventBus.js';
import TabletViewChildCheckInCard from './TabletViewChildCheckInCard.vue';
import TabletViewChildMoodsCard from './TabletViewChildMoodsCard.vue';
import TabletViewPickupList from './TabletViewPickupList.vue';
import TabletViewSortButton from './TabletViewSortButton.vue';

export default {
    components: {
        'kgr-tablet-view-sort-button': TabletViewSortButton,
        'kgr-tablet-view-child-card': TabletViewChildCheckInCard,
        'kgr-tablet-view-child-moods-card': TabletViewChildMoodsCard,
        'kgr-tablet-view-pickup-list': TabletViewPickupList,
    },
    props: {
        initialChildren: {
            type: Array,
            required: true,
        },
        initialGroups: {
            type: Array,
            required: true,
        },
        initialKindergarten: {
            type: Object,
            required: true,
        },
        moodBarometerEnabled: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            menu: 'selection',
            selectedGroups: [],
            groups: [],
            children: [],
            kindergarten: {},
            error: false,
            pickupPermissionChild: null,
            sort: {
                checkIn: {
                    firstname: null,
                    lastname: null,
                    checkIn: null,
                },
                checkOut: {
                    firstname: null,
                    lastname: null,
                    checkOut: null,
                },
                moodBarometer: {
                    firstname: null,
                    lastname: null,
                }
            },
        }
    },
    computed: {
        storageKey() {
            return 'selectedGroups_' + this.kindergartenId;
        },
        menuCheckIn() {
            return this.menu === 'checkIn';
        },
        menuCheckOut() {
            return this.menu === 'checkOut';
        },
        menuMoodBarometer() {
            return this.menu === 'moodBarometer';
        },
        menuSelection() {
            return this.menu === 'selection';
        },
        navigationIsVisible() {
            return !this.menuSelection;
        },
        groupIds() {
            let groupIds = [];
            for (let i = 0; i < this.groups.length; i++) {
                groupIds.push(this.groups[i].id);
            }
            return groupIds;
        },
        childrenWithStatusNotHereYet() {
            return this.getChildrenWithStatus('notHereYet').sort(this.compareFunction);
        },
        childrenWithStatusPresent() {
            return this.getChildrenWithStatus('present').sort(this.compareFunction);
        },
        childrenWithStatusAbsent() {
            return this.getChildrenWithStatus('absent').sort(this.compareFunction);
        },
        childrenWithStatusPickedUp() {
            return this.getChildrenWithStatus('pickedUp').sort(this.compareFunction);
        },
        childrenWithStatusNotHereYetAvailable() {
            return this.childrenWithStatusNotHereYet.length > 0;
        },
        childrenWithStatusPresentAvailable() {
            return this.childrenWithStatusPresent.length > 0;
        },
        childrenWithStatusAbsentAvailable() {
            return this.childrenWithStatusAbsent.length > 0;
        },
        childrenWithStatusPickedUpAvailable() {
            return this.childrenWithStatusPickedUp.length > 0;
        },
        compareFunction() {
            let sort = this.sort[this.menu];
            if(!sort) {
                return function() { return 0};
            }
            if (sort.firstname !== null) {
                return function (a, b) {
                    if (sort.firstname === 'asc') {
                        return a.firstname.localeCompare(b.firstname);
                    } else {
                        return b.firstname.localeCompare(a.firstname);
                    }
                }
            }
            if (sort.lastname !== null) {
                return function (a, b) {
                    if (sort.lastname === 'asc') {
                        return a.lastname.localeCompare(b.lastname);
                    } else {
                        return b.lastname.localeCompare(a.lastname);
                    }
                }
            }
            if (sort.checkIn) {
                return function (a, b) {
                    if (sort.checkIn === 'asc') {
                        return a.checkinTime.localeCompare(b.checkinTime);
                    } else {
                        return b.checkinTime.localeCompare(a.checkinTime);
                    }
                }
            }
            if (sort.checkOut) {
                return function (a, b) {
                    if (sort.checkOut === 'asc') {
                        return a.checkoutTime.localeCompare(b.checkoutTime);
                    } else {
                        return b.checkoutTime.localeCompare(a.checkoutTime);
                    }
                }
            }
            return function() { return 0};
        }
    },
    mounted() {
        this.children = this.initialChildren;
        this.groups = this.initialGroups;
        this.kindergarten = this.initialKindergarten;
        this.initLocalstorage();
        this.ticktack();
        $.ajaxSetup({
            timeout: 15000, //Time in milliseconds
            dataType: 'json'
        });
        localStorage.removeItem('update_children');
        localStorage.removeItem('checkin_update');

        setInterval(function () {
            this.get_children();
        }.bind(this), 60000);
    },
    methods: {
        setLocalStorageSortOrder(field, order) {
            localStorage.setItem(this.menu + ':sort', JSON.stringify([field, order]));
        },
        setDefaultSortOrder() {
            let item = localStorage.getItem(this.menu + ':sort');
            let parsed = item ? JSON.parse(item) : null;
            if(parsed) {
                this.sort[this.menu][parsed[0]] = parsed[1];
            } else {
                this.sort[this.menu]['firstname'] = 'asc';
            }
        },
        sortFirstname(order) {
            let context = this.menu;
            this.sort[context].firstname = order;
            this.sort[context].lastname = null;
            this.sort[context].checkIn = null;
            this.sort[context].checkOut = null;
            this.setLocalStorageSortOrder('firstname', order);
        },
        sortLastname(order) {
            let context = this.menu;
            this.sort[context].lastname = order;
            this.sort[context].firstname = null;
            this.sort[context].checkIn = null;
            this.sort[context].checkOut = null;
            this.setLocalStorageSortOrder('lastname', order);
        },
        sortCheckin(order) {
            let context = this.menu;
            this.sort[context].checkIn = order;
            this.sort[context].firstname = null;
            this.sort[context].lastname = null;
            this.sort[context].checkOut = null;
            this.setLocalStorageSortOrder('checkIn', order);
        },
        sortCheckout(order) {
            let context = this.menu;
            this.sort[context].checkOut = order;
            this.sort[context].checkIn = null;
            this.sort[context].firstname = null;
            this.sort[context].lastname = null;
            this.setLocalStorageSortOrder('checkOut', order);
        },
        updateAttendance(event) {
            let childId = event.id;
            this.children.filter(child => child.id === childId)[0].attendanceId = event.attendanceId;
        },
        showPickupPermission(child) {
            if (this.pickupPermissionChild) {
                return;
            }
            this.pickupPermissionChild = child;
            $('#checkin_overlay').fadeIn();
            $('.pickuplist-container').fadeIn();
            $('<div class=\'dummyCard\'></div>').insertAfter('#child-' + child.id);
            $('#child-' + child.id).addClass('show-on-top');
        },
        hidePickupPermission() {
            $('.dummyCard').remove();
            if (this.pickupPermissionChild !== null) {
                $('.pickuplist-container').hide();
                $('#checkin_overlay').fadeOut();
                $('#child-' + this.pickupPermissionChild.id).removeClass('show-on-top');
                this.pickupPermissionChild = null;
            }
        },
        onCardError(oldChild) {
            this.error = true;
            if (oldChild) {
                this.children = this.children.map(child => child.id === oldChild.id ? oldChild : child);
            }
        },
        resetView() {
            this.hidePickupPermission();
            EventBus.$emit('reset_tablet_view');
        },
        initLocalstorage() {
            this.selectedGroups = JSON.parse(localStorage.getItem(this.storageKey));
            if (this.selectedGroups == null) {
                localStorage.setItem(this.storageKey, JSON.stringify(this.groupIds));
                this.selectedGroups = JSON.parse(localStorage.getItem(this.storageKey));
            }
        },
        ticktack() {
            let self = this;
            $.grep(this.children, function (child) {
                let timeNow = self.getCurrentClock();
                if (child.updateCheckinTimer) {
                    child.checkinTime = timeNow;
                }
                if (child.updateCheckoutTimer) {
                    child.checkoutTime = timeNow;
                }
            });
            setTimeout(function () {
                self.ticktack()
            }, 60000);
        },
        getCurrentClock() {
            let date = new Date;
            let m = date.getMinutes();
            let h = date.getHours();
            return ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);
        },
        isGroupSelected(groupId) {
            return $.inArray(groupId, this.selectedGroups) !== -1;
        },
        toggleGroup(groupId) {
            this.resetView();
            if (this.isGroupSelected(groupId)) {
                this.removeGroup(groupId);
            } else {
                this.addGroup(groupId);
            }
            localStorage.setItem(this.storageKey, JSON.stringify(this.selectedGroups));
        },
        addGroup(groupId) {
            this.selectedGroups.push(groupId);
        },
        removeGroup(groupId) {
            this.selectedGroups.splice($.inArray(groupId, this.selectedGroups), 1);
        },
        isInVisibleGroup(child) {
            let isInVisibleGroup = false;
            let that = this;
            $.each(child.groupIds, function (index, group) {
                if (that.isGroupSelected(group)) {
                    isInVisibleGroup = true;
                }
            });

            return isInVisibleGroup;
        },

        hasStatus(child, status) {
            return $.inArray(status, child.status) !== -1;
        },
        getChildrenWithStatus(status) {
            let that = this;
            return $.grep(this.children, function (child) {
                return that.isInVisibleGroup(child) && that.hasStatus(child, status);
            });
        },
        childrenWithStatusesAvailable(statuses) {
            let that = this;
            return $.grep(this.children, function (child) {
                if (!that.isInVisibleGroup(child)) {
                    return false;
                }

                let hasStatus = false;
                statuses.forEach(status => {
                    if (that.hasStatus(child, status)) {
                        hasStatus = true;
                        return;
                    }
                });
                return hasStatus;
            }).length > 0;
        },
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        get_children() {
            let self = this;
            if (localStorage.getItem('checkin_update') || this.error) {
                return false;
            }
            localStorage.setItem('checkin_update', true);

            $.post(
                '/backend/checkin/get',
                data => {
                    this.children.forEach((child, index) => {
                        data.forEach(dataChild => {
                            if (dataChild.id === child.id && dataChild.checksum !== child.checksum) {
                                this.$set(this.children, index, dataChild);
                            }
                        });
                    }
                    );

                    self.ticktack();
                    // workaround
                    self.resetView();
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error);
                localStorage.removeItem('checkin_update');
            });
        },
        hide_infoBox(key) {
            this.error = false;
            $('.checkin_' + key).animate({
                'top': '-150px'
            }, 'fast', function () {
                $('.checkin_' + key).fadeOut();
            });
            $('.checkin_message').html();
            $('#checkin_overlay').fadeOut();
            $('.checkin_message_close').hide();
            $('.checkin_message_login').hide();
        },
        handle_ajax_error(xhr, status, error, child) {
            if (child) {
                this.onError(child);
            }
            if ('timeout' === status) {
                this.show_info('infoBox', 'error', this.$t('Es ist ein Problem aufgetreten, bitte überprüfen Sie Ihre Online Verbindung und laden Sie die Seite bitte neu.'));
                $('.checkin_message_close').show();
                return;
            }
            if (403 === xhr.status) {
                this.show_info('infoBox', 'error', this.$t('Sie wurden aus Sicherheitsgründen ausgeloggt, bitte loggen Sie sich erneut ein.'));
                $('.checkin_message_login').show();
                return;
            }
            if (200 !== xhr.status) {
                if (child) {
                    let message = this.$t('Die Daten für {name} konnten nicht gespeichert werden. Bitte wiederholen Sie den Vorgang.', {'name': this.child.firstname + ' ' + this.child.lastname});
                    this.show_info('infoBox', 'error', message);
                    $('.checkin_message_close').show();
                } else {
                    this.show_info('infoBox', 'error', this.$t('Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu.'));
                    $('.checkin_message_close').show();
                }
            }
        },
        show_info(key, status, message) {
            $('#checkin_overlay').fadeIn();
            if (status === 'error') {
                $('#checkin_message_headline').html('<h3>' + this.$t('Achtung!') + '</h3>');
            }
            $('#checkin_message').html(message);
            $('.checkin_' + key).addClass(status).fadeIn().animate({
                'top': '70px'
            });
        },
        showSelection() {
            this.menu = 'selection';
            this.resetView();
        },
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.tabletView {
    .dummyCard {
        width: 180px;
        margin: 0 10px;
        height: 355px;
        box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 2px;
        border: 0;
        background-color: #f5f5f5;
    }

    .row h2 {
        text-align: center;
    }

    .notice h3 {
        text-align: center;
        margin-top: 60px;
    }

    h3 {
        font-weight: var(--kgr-font-weight-bold);
        margin-top: 0;
    }

    a:link {
        text-decoration: none;
    }

    #header, #footer {
        z-index: 20;
        background: #909090;
        width: 100%;
        left: 0;
    }

    #footer {
        position: fixed;
    }

    #header {
        min-height: 70px;
        top: 0;

        padding: 0;
        margin: 0;
    }

    #footer {
        bottom: 0;
        border-top: 1px solid #666;
        background-color: #0071ad;
        color: white;
        font-size: 20px;
        font-weight: var(--kgr-font-weight-bold);
        text-align: center;
    }

    #footer .row {
        height: 80px;
        line-height: 80px;
    }

    .dashboard-header {
        min-height: 75px;
        padding: 10px 0;
        border-bottom: 1px solid #909090;
        background: rgba(32, 146, 207, 1);
        background: linear-gradient(to bottom, rgba(32, 146, 207, 1) 0%, rgba(0, 114, 176, 1) 100%);
        box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.4);
    }

    .dashboard-list {
        margin-left: 230px;
        margin-right: 300px;
        padding: 5px 10px;
    }

    .sort-buttons {
        margin-left: 222px;
    }

    .dashboard-list > li, .dashboard-return > li {
        float: left;
        list-style-type: none;
        border-radius: 4px;
        border: 1px solid #989898;
        margin: 0 3px 8px;
        padding: 5px 10px;
        color: rgba(255, 255, 255, 0.84);
        cursor: pointer;
    }

    .dashboard-list > li, .dashboard-return > li {
        margin: 2px;
    }

    .dashboard-return {
        position: absolute;
        right: 5px;
        top: 20px;
    }

    .child-image-container {
        height: 165px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        margin: 10px;
    }

    .card-content .child-image {
        position: relative;
        min-width: 140px;
        border: 1px solid lightgrey;
    }

    .card-content textarea, .card-content input {
        border: 1px solid lightgrey;
        font-weight: var(--kgr-font-weight-normal);
        font-size: 13px;
    }

    .card-content label {
        margin: 0;
    }

    .btn-press {
        background: #4CAF50 !important;
    }

    .btn-dontpress {
        background: #2196F3 !important;
    }

    .card a {
        color: white;
    }

    .card-footer span {
        color: white;
    }

    .active {
        /*margin: 0 5px;*/
        background-color: rgba(256, 256, 256, 0.5);
        border: 1px solid white !important;
    }

    #dashboard-kindergartenlogo {
        position: absolute;
        z-index: 20;
        padding: 15px;
    }

    #dashboard-kindergartenlogo img {
        max-width: 200px;
        max-height: 130px;
        padding: 5px;
        box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.4);
    }

    #dashboard .btn {
        padding: 0;
    }

    .content {
        width: 100%;
        padding: 100px 30px;
    }

    .main-selection {
        display: flex;
        align-items: center;
    }

    .selection-nav-icon {
        font-size: 100px;
    }

    .icon-user-plus {
        color: #4CAF50;
    }

    .icon-user-times {
        color: #F44336;
    }

    .mood-nav-icon {
        color: #FFC107;
        font-weight: var(--kgr-font-weight-bold);
    }

    .dashboard-choice p {
        font-size: 30px;
        color: black;
    }

    .icon-home {
        font-size: 20px;
    }

    .selection-icon {
        font-size: 120px;
    }

    .menu-icon {
        position: absolute;
        top: 15px;
        right: 70px;
    }

    .menu-icon i {
        font-size: 75px;
    }

    .children {
        display: flex;
        flex-wrap: wrap;
        margin-left: -10px;
        margin-right: -10px;
    }

    .children .child {
        width: 200px;
        position: relative;
        margin-bottom: 25px;
    }

    .children .child .btn-group {
        position: absolute;
        top: -6px;
        right: -17px;
    }

    .children .child img {
        width: 100%;
        padding: 10px;
        height: 185px;
    }

    .children .child h2 {
        margin-top: 0;
    }

    .turn-card {
        position: absolute;
        right: 8px;
        top: 8px;
        font-size: 32px;
    }

    a.btn-fab:hover {
        background-color: #eee !important;
    }

    .expand-transition {
        transition: all 0.5s ease;
    }

    .expand-enter, .expand-leave {
        opacity: 0;
    }

    input[type=text], textarea {
        width: 100%;
    }

    .card-content {
        height: 260px;
    }

    .attendance-time-info {
        height: 80px;
    }

    .applet .btn {
        text-transform: inherit;
        height: 40px;
        line-height: 40px;
    }

    .applet .but-two-lines {
        line-height: 19px;
    }

    .applet .btn:hover, .applet .but-two-lines:hover {
        color: white;
    }

    .btn-turn-around {
        position: absolute;
        top: 10px;
        right: 0;
        width: 30px;
        height: 25px;
        line-height: 29px;
        cursor: pointer;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        -webkit-box-shadow: inset 4px 3px 12px 0 rgba(130, 130, 130, 1);
        -moz-box-shadow: inset 4px 3px 12px 0 rgba(130, 130, 130, 1);
        box-shadow: inset 1px 1px 7px -2px rgba(130, 130, 130, 1);
    }

    .absent, .absentInfo {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 118px;
        height: 165px;
        background: rgba(255, 255, 255, 0.8);
        font-size: 15px;
        font-weight: var(--kgr-font-weight-bold);
    }

    .absent i span {
        margin-left: 3px;
    }

    .absentSave {
        height: 25%;
        padding: 14px 0 0 7px;
        cursor: pointer;
        border-bottom: 1px solid lightgrey;
        font-size: 12px;
        font-weight: var(--kgr-font-weight-bold);

    }

    .absentInfo {
        height: 165px;
        padding-top: 65px;
    }

    .info-btn {
        position: absolute;
        top: 10px;
        width: 30px;
        height: 25px;
        line-height: 25px;
        border-radius: 6px;
        cursor: pointer;
        border: 1px solid lightgray;
        background-color: #f5f5f5;
    }

    .btn-pickuppermissions {
        left: 5px;
    }

    .btn-absent {
        left: 37px;
    }

    .card-choice {
        -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 2px;
        border: 0;
    }


    /* ####################################################################### */

    .card {
        transform-style: preserve-3d; /* Kind-Elemente  (.front + .back) sollen ihre 3D-Eigenschaften behalten*/
        position: relative;
        margin: 0 10px;
        border-radius: 2px;
        border: 0;
        height: 350px;
    }

    .flip {
        -webkit-perspective: 1000px;
        perspective: 1000px;
    }

    .child-front, .child-back {
        width: 180px;
        transition: 1s;
        position: absolute;
        top: 0;
        left: 0;
        padding: 35px 20px 20px 20px;
        backface-visibility: hidden;
        margin-right: 10px;
        box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 2px;
        border: 0;
        background-color: #f5f5f5;
    }

    .child-front {
        z-index: 2;
        transform: rotateY(0deg);
    }

    .child-back {
        z-index: -1;
        transform: rotateY(180deg);
    }

    .card-flipped .child-front {
        z-index: -1;
        transform: rotateY(-180deg);
    }

    .card-flipped .child-back {
        z-index: 2;
        transform: rotateY(0deg);
    }

    .card-flipped .btn-turn-around {
        z-index: -1;
    }

    .rot180 {
        transform: rotateY(180deg);
    }

    .div-show {
        display: block;
    }

    .div-hide {
        display: none;
        z-index: -1;
    }

    .header-path {
        color: white;
        position: absolute;
        top: 10px;
        right: 170px;
    }

    .infoIcon {
        display: flex;
        flex-direction: column-reverse;
        position: absolute;
        width: 19px;
        top: 100px;
        left: 0;
        cursor: pointer;
    }

    .delete-absence {
        position: absolute;
        bottom: 0;
        right: 5px;
        cursor: pointer;
        color: rgba(0, 0, 0, 1);
    }

    .delete-absence-trans {
        cursor: default;
        color: rgba(0, 0, 0, 0.3);
    }

    .but-hint {
        font-size: 12px;
        font-weight: var(--kgr-font-weight-normal);
    }

    .checkin_infoBox {
        position: fixed;
        width: 30%;
        min-height: 100px;
        padding: 35px 25px 25px 25px;
        top: -150px;
        left: calc(50% - 15%);
        z-index: 10;
        border-radius: 4px;
        border: 1px solid #989898;
        display: none;
        color: white;
        text-align: center;

    }

    .checkin_infoBox .checkin_message_close {
        display: none;
    }

    .checkin_infoBox .checkin_message_login {
        display: none;
    }

    .checkin_infoBox .checkin_button {
        cursor: pointer;
        border-radius: 4px;
        border: 1px solid #FFFFFF;
        margin-top: 25px;
        padding: 5px 20px;
    }

    .checkin_infoBox_footer {
        margin-top: 30px;
    }

    .error {
        background-color: rgba(244, 67, 54, 1);
    }

    #checkin_overlay {
        display: none;
        background-color: rgba(0, 0, 0, 0.8);
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 10;
    }

    @media (min-width: 1000px) {
        #header {
            position: fixed;
        }
    }

    @media (max-width: 1000px) {
        .content {
            padding-top: 40px;
        }
    }
}
</style>
